import { api } from "@/lib/api";

export function getWhatsAppLink(number, message) {
  const text = encodeURIComponent(
    message || "Merhaba, Meta reklam yönetimi hakkında bilgi almak istiyorum"
  );
  return `https://wa.me/${number}?text=${text}`;
}

export function trackWhatsAppClick(location) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "contact", { method: "whatsapp", location });
    }
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Contact", { location });
    }
  } catch (e) {
    /* analytics should never break the UI */
  }
  api.post("/track/whatsapp-click", { location }).catch(() => {});
}
